import React from 'react';
import { Typography } from '@mui/material';

import { COLOR_GREY_DARK, COLOR_TEAL_SURFACE, COLOR_WHITEISH } from '../../../theme';

export const sectionBandSx = {
    px: { xs: 1.5, sm: 2 },
    py: 1,
    bgcolor: COLOR_WHITEISH,
    borderBottom: `1px solid ${COLOR_TEAL_SURFACE}`,
    color: COLOR_GREY_DARK,
    fontSize: '0.75rem',
    fontWeight: 700,
    letterSpacing: '0.08em',
    textTransform: 'uppercase'
} as const;

/** Small uppercase band that titles a group of rows inside a Paper (padding 0). */
export default function SectionHeader({ children }: { children: React.ReactNode }) {
    return (
        <Typography component="h2" sx={sectionBandSx}>
            {children}
        </Typography>
    );
}
